var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.waitInit)?_c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":['NewsList', 'Announcement']}},[_c('router-view')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }